import mbaas from "./Mbaas";

export const KYC_URL_SCRIPT = "console-sip-upload-download-url";

export type KycOps = "UPLOAD" | "DOWNLOAD";

export const requestKycUrl = (
  filename: string,
  ops: KycOps,
): Promise<any> =>
  mbaas.client.invokeApi(KYC_URL_SCRIPT, { filename, ops });
